import React, { FC } from 'react';

import { Modal } from '~shared/ui/feedback';

import { PdfUrlViewer } from '../PdfUrlViewer';

export interface PdfModalViewerProps {
  button: React.ReactNode;
  pdfUrl: string;
}

export const PdfModalViewer: FC<PdfModalViewerProps> = ({ button, pdfUrl, ...props }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div onClick={handleOpen} {...props}>
        {button}
      </div>
      <Modal open={isOpen} onCancel={handleClose} footer={null} {...props} centered width={1000}>
        <PdfUrlViewer pdfUrl={pdfUrl} />
      </Modal>
    </>
  );
};
